<template>
  <UiInputSelectVeeBase v-bind="{ ...$props, ...$attrs }" />
</template>

<script lang="ts">
import type { PropType } from 'vue'
import type { TValidationRules } from '@team-milva/lab-components'

interface ISelectOption {
  value: string
  text: string
}

export default {
  name: 'UiInputSelectVee',
  inheritAttrs: false,
  props: {
    name: { type: String, required: true as const },
    label: { type: String, default: undefined },
    modelValue: { type: String, required: true as const },
    unselectedText: { type: String, default: undefined },
    options: { type: Array as PropType<ISelectOption[]>, required: true as const },
    rules: { type: Array as PropType<TValidationRules[]>, default: undefined },
    showAsRequired: { type: Boolean, default: undefined },
    isRequired: { type: Boolean, default: undefined },
    isDisabled: { type: Boolean, default: undefined },
  },
}
</script>

